import React from 'react'

function Alldeskphones() {
  return (
    <div>Alldeskphones</div>
  )
}

export default Alldeskphones